import { fromFetch } from 'rxjs/fetch';
import { z } from 'zod/v4';

import { requiredHeaders } from '../../../models/required-headers';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { mapManagementServiceEnvironment } from '../map-management-service-environment';
import { RuleFields } from '../schemas/rule.schema';

/**
 * Updates one or more rules
 * @param rules The rules being updated
 * @returns Data object indicating success
 */
export function putRules(this: unknown, rules: RuleFields[]) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(mapManagementServiceEnvironment.resolve(this).rulesUrl, {
        method: 'PUT',
        headers: {
          ...requiredHeaders,
          ...jwtAuthHeaders,
        },
        body: JSON.stringify(rules),
      })
    )
  ).pipe(
    selectData(
      z.object({
        message: z.string(),
      })
    )
  );
}
